import React, { Component } from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import CustomDatePickerInput from "../_common/CustomDatePickerInput";
import PageNav from "../_common/PageNav";
import TitleBar from "../_common/TitleBar";
import adrListTitleBarMenu from "../_titleBarMenus/adrListTitleBarMenu";
import _ from "lodash";
import Table from "../_common/Table";
import adrActions from "../../_actions/adrActions";
import moment from "moment";
// import BlockUi from "react-block-ui";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from "reactstrap";
// import AdrListSearchBar from "./adrListSearchBar";
// import "react-block-ui/style.css";
import "loaders.css/loaders.min.css";
import "./adrList.css";
import { actionScripts } from "../../_helpers/actionScripts";
import FilterGroup from "../_common/FilterGroup";
import { getPermissions } from "../../_helpers/authorize";
import { DOCTYPE } from "../../_constants/docTypeConstants";
import { projSelectorConstants } from "../../_constants/projSelectorConstants";
import { docPermConstants } from "../../_constants/permissionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdrPreview from "./AdrPreview";
import AlertModal from "../_common/AlertModal";
import cem4601PdfActions from "../../_actions/cem4601PdfActions";
import projActions from "../../_actions/projActions";
import { stringifyJSON } from "../../_utils/generalUtils";

class AdrList extends Component {
  state = {
    reportDateFrom: null, // Date; report date range filter (project list only)
    reportDateTo: null, // Date
    sortColumn: { path: "reportStartDate", order: "desc" },
    dateFilter: null,
    authorFilter: "",
    selectedStatusFilters: [],
    selectedOnlyFilter: false,
    disableAllSort: false,
    selectedAdr: null, // set from handleClick_tr
    selectedAdrs: {},
    selectedAll: false, // toggler to determine whether to clear selections
    selectedAdrPreviewData: null,
    permissions: null, // initialized in cdm
    showAlert_deleteConfirm: false,
  };

  columns = [
    {
      path: "select",
      label: <FontAwesomeIcon icon="check-square" className="fa-fw" />,
      thClassName: "adrlist-th-select table-tr-md-edge",
      tdClassName: "table-tr-md-edge align-middle",
      content: (adr) => this.renderAdrSelect(adr),
      customHeaderClick: () => this.toggleSelectAll(),
      disableSort: true,
    },
    {
      path: "reportStartDate",
      label: "Date",
      thClassName: "adrlist-th-date table-tr-md",
      tdClassName: "adrlist-th-date table-tr-md align-middle",
      content: (adr) => (
        <span className={`${adr.isSuperseded ? "text-muted font-italic" : ""}`}>
          {`${moment(adr.reportStartDate).format("MM/DD/YYYY")}`}
        </span>
      ),
    },
    {
      path: "reportNo",
      label: "Rpt",
      thClassName: "adrlist-th-rptno table-tr-md",
      tdClassName: "adrlist-th-rptno table-tr-md align-middle",
      content: (adr) => (
        <span className={`${adr.isSuperseded ? "text-muted font-italic" : ""}`}>
          {adr.reportNo}
        </span>
      ),
    },
    {
      path: "authorFullName",
      label: "Author",
      thClassName: "adrlist-th-author table-tr-md",
      tdClassName: "adrlist-th-author table-tr-md align-middle",
      content: (adr) => (
        <span className={`${adr.isSuperseded ? "text-muted font-italic" : ""}`}>
          {adr.authorFullName}
        </span>
      ),
    },
    {
      path: "status",
      label: "Status",
      thClassName: "adrlist-th-status table-tr-md",
      tdClassName: "adrlist-th-status table-tr-md align-middle",
      content: (adr) => this.renderAdrStatus(adr),
    },
    // {
    //   path: "statusDate",
    //   label: "Status Date",
    //   thClassName: "adrlist-th-statusDate table-tr-md",
    //   thColSpan: "2",
    //   tdClassName: "adrlist-td-statusDate table-tr-md align-middle",
    //   content: (adr) => moment(adr.statusDate).format("L"),
    // },
    {
      path: "snippets",
      label: "",
      thClassName: "adrlist-th-statusDate table-tr-md",
      tdClassName: "adrlist-th-statusDate table-tr-md align-middle",
      disableSort: true,
      content: (adr) => this.renderSnippet(adr),
    },
    {
      path: "openAdr",
      label: "",
      thClassName: "adrlist-th-openAdr table-tr-md",
      tdClassName: "adrlist-th-openAdr table-tr-md-edge text-right align-middle",
      content: (adr) => this.renderPreviewLink(adr),
      disableSort: true,
    },
  ];

  componentDidMount() {
    const { dispatch, tab, user, isSearchResult } = this.props;

    // Project list opens on the latest page of reports (see adrActions.defaultListQuery)
    if (!isSearchResult)
      dispatch(adrActions.fetchPage(tab.projectId, tab.tabId, adrActions.defaultListQuery));

    this.setState({
      permissions: getPermissions({
        user,
        docType: DOCTYPE.ADR,
        projectId: tab.projectId,
        creatorId: null,
      }),
    });
  }

  componentDidUpdate(prevProps) {
    // A modified search replaces this tab's results; drop selections from the old results.
    if (this.props.isSearchResult && prevProps.searchParams !== this.props.searchParams)
      this.setState({
        selectedAdrs: {},
        selectedAll: false,
        selectedAdr: null,
        selectedAdrPreviewData: null,
      });
  }

  clearSelections = () =>
    this.setState({
      selectedAdrs: {},
      selectedAll: false,
      selectedOnlyFilter: false,
      selectedAdr: null,
      selectedAdrPreviewData: null,
    });

  /**
   * Project list only: re-fetch from the server with the current query plus `changes`.
   * Any change other than refreshing the same page clears selections, since selected
   * rows may no longer be on screen.
   */
  fetchListPage = (changes = {}) => {
    const { dispatch, tab, listQuery } = this.props;
    if (Object.keys(changes).length > 0) this.clearSelections();
    return dispatch(
      adrActions.fetchPage(tab.projectId, tab.tabId, {
        ...(listQuery || adrActions.defaultListQuery),
        ...changes,
      })
    );
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
    // Search results are sorted in the browser; the project list is sorted by the server.
    if (!this.props.isSearchResult)
      this.fetchListPage({
        sortBy: sortColumn.path,
        sortDesc: sortColumn.order === "desc",
        page: 1,
      });
  };

  handleChange_reportDate = (field) => (date) => {
    const toParam = (d) => (d ? moment(d).format("YYYY-MM-DD") : null);
    const reportDateFrom = field === "from" ? date : this.state.reportDateFrom;
    const reportDateTo = field === "to" ? date : this.state.reportDateTo;
    this.setState({ reportDateFrom, reportDateTo });
    const dateFrom = toParam(reportDateFrom);
    const dateTo = toParam(reportDateTo);
    // The date input reports on both typing and blur; skip re-fetching an unchanged range.
    const { listQuery } = this.props;
    if (listQuery && listQuery.dateFrom === dateFrom && listQuery.dateTo === dateTo) return;
    this.fetchListPage({ dateFrom, dateTo, page: 1 });
  };

  handleClick_clearReportDates = (e) => {
    e.preventDefault();
    this.setState({ reportDateFrom: null, reportDateTo: null });
    this.fetchListPage({ dateFrom: null, dateTo: null, page: 1 });
  };

  handleChange_page = (page) => this.fetchListPage({ page });

  handleChange_pageSize = (e) =>
    this.fetchListPage({ pageSize: parseInt(e.target.value, 10), page: 1 });

  toggleSelectAll = () => {
    const { selectedAll } = this.state;
    if (!selectedAll) {
      const data = this.getData();
      let selectedAdrs = {};
      data.forEach((adr) => (selectedAdrs[adr.assistantDailyReportId] = true));
      this.setState({ selectedAdrs, selectedAll: true });
    } else this.setState({ selectedAdrs: {}, selectedAll: false });
  };

  deselectFilteredOutItems = () => {
    const adrIds = this.getData().map((adr) => adr.assistantDailyReportId);
    const selectedAdrs = { ...this.state.selectedAdrs };
    const adrIdsToDeselect = Object.keys(selectedAdrs).filter(
      (adrId) => !adrIds.includes(+adrId)
    );
    adrIdsToDeselect.forEach((adrId) => (selectedAdrs[adrId] = false));
    this.setState({ selectedAdrs });
  };

  handleChange_dateFilter = (dateFilter) =>
    this.setState({ dateFilter }, this.deselectFilteredOutItems);

  handleChange_authorFilter = (e) =>
    this.setState({ authorFilter: e.target.value }, this.deselectFilteredOutItems);

  handleChange_statusFilter = (selectedStatusFilters) => {
    // Project list: the server applies status filters across all pages.
    if (!this.props.isSearchResult) {
      this.setState({ selectedStatusFilters });
      this.fetchListPage({ statuses: selectedStatusFilters, page: 1 });
      return;
    }
    this.setState(
      {
        selectedStatusFilters,
        disableAllSort: selectedStatusFilters.length > 0,
      },
      this.deselectFilteredOutItems
    );
  };

  handleClick_selectedOnlyFilter = (e) => {
    e.preventDefault();
    this.setState(
      { selectedOnlyFilter: !this.state.selectedOnlyFilter },
      this.deselectFilteredOutItems
    );
  };

  handleClick_clearFilters = (e) => {
    e.preventDefault();
    this.setState({ dateFilter: null, authorFilter: "" });
  };

  handleClick_createNewAdr = (e) => {
    const { tab, user } = this.props;
    e.preventDefault();
    actionScripts.CREATE_ADR_V2.run(user.userId, tab.projectId);
  };

  handleChange_check = (adrId) => (e) => {
    e.stopPropagation();
    const selectedAdrs = { ...this.state.selectedAdrs };
    selectedAdrs[adrId] = e.target.checked;
    // Individual selections should disable selectedAll toggler
    this.setState({ selectedAdrs, selectedAll: false });
  };

  handleTitleBarAction = (action) => () => {
    // Re-fetch the current page, keeping filters, sort and page number.
    if (action === "refreshAdrList") this.fetchListPage();
  };

  handleAlert_deleteConfirm = (alertAction) => (e) => {
    e.preventDefault();
    if (alertAction === "accept") {
      const { selectedAdrs } = this.state;
      const { tab, adrList, user } = this.props;
      const selectedAdrIds = Object.entries(selectedAdrs)
        .filter((kvp) => kvp[1])
        .map((kvp) => +kvp[0]);
      selectedAdrIds.forEach((adrId) => {
        const adr = adrList.find((a) => a.assistantDailyReportId === adrId);
        if (adr && adr.authorUserId === user.userId)
          actionScripts.DELETE_ADR.run(tab.projectId, adrId, null);
      });

      // Clear selections
      this.setState({ selectedAdrs: {} });
    }
    this.toggleAlert_deleteConfirm();
  };

  toggleAlert_deleteConfirm = () => {
    this.setState({ showAlert_deleteConfirm: !this.state.showAlert_deleteConfirm });
  };

  getData = () => {
    const { adrList, user, isSearchResult } = this.props;

    // Project list: the server already filtered, sorted and paged the rows.
    if (!isSearchResult) {
      const { selectedOnlyFilter, selectedAdrs } = this.state;
      const rows = adrList || [];
      return selectedOnlyFilter
        ? rows.filter((adr) => selectedAdrs[adr.assistantDailyReportId])
        : rows;
    }

    const {
      sortColumn,
      dateFilter,
      authorFilter,
      selectedStatusFilters,
      selectedOnlyFilter,
      selectedAdrs,
      projectRoleClass,
    } = this.state;

    // Hide others' drafts and deleted
    const draftHidden = adrList
      ? adrList.filter(
          (adr) => !(adr.isDraft && adr.authorUserId !== user.userId) || adr.isDeleted
        )
      : [];

    const filteredByDate = dateFilter
      ? draftHidden.filter((i) => moment(i.reportStartDate).isSame(dateFilter, "day"))
      : draftHidden;
    const filteredByAuthor =
      authorFilter !== ""
        ? filteredByDate.filter((i) =>
            i.authorFullName.toLowerCase().includes(authorFilter.trim().toLowerCase())
          )
        : filteredByDate;
    let filteredByStatus =
      selectedStatusFilters.length > 0
        ? filteredByAuthor.filter(
            (adr) =>
              (selectedStatusFilters.includes("Draft") && adr.isDraft) ||
              (selectedStatusFilters.includes("Submitted") && adr.isSubmitted) ||
              (selectedStatusFilters.includes("Rejected") && adr.isRejected) ||
              (selectedStatusFilters.includes("Accepted") && adr.isApproved)
          )
        : filteredByAuthor;

    let sorted = [];

    // If status filters are selected, then enforce sorting by status orders
    // as defined in the Specifications.
    // Otherwise, allow user to custom sort by clicking table headers.
    if (filteredByStatus !== undefined && selectedStatusFilters.length > 0) {
      switch (projectRoleClass) {
        case "ARESR": {
          // Define the sort order of status - i.e. for ARESR, 'Rejected' will
          // always be at the top, sorted reverse chronologically.
          const statusOrder = ["Rejected", "Draft", "Submitted"];
          // The matching index of the statusOrder array defines sorting order.
          // Save the sorting order as a new property in filteredByStatus,
          // which is a temporary store of the adrList data.
          // There are 4 total statuses, so with 0-base index, 3 is maximum -
          // basically, if no matching status is found, show it last.
          filteredByStatus.forEach((adr) =>
            statusOrder.includes(adr.status)
              ? (adr.statusSortOrder = statusOrder.findIndex((so) => so === adr.status))
              : 3
          );
          sorted = _.orderBy(
            filteredByStatus,
            ["statusSortOrder", "reportStartDate"],
            ["asc", "desc"]
          );
          break;
        }
        case "RESR": {
          // See above case for documentation.
          const statusOrder = ["Submitted", "Rejected", "Accepted"];
          filteredByStatus.forEach((adr) =>
            statusOrder.includes(adr.status)
              ? (adr.statusSortOrder = statusOrder.findIndex((so) => so === adr.status))
              : 3
          );
          sorted = _.orderBy(
            filteredByStatus,
            ["statusSortOrder", "reportStartDate"],
            ["asc", "desc"]
          );
          break;
        }
        default: {
          sorted = _.orderBy(filteredByStatus, [sortColumn.path], [sortColumn.order]);
        }
      }
    } else sorted = _.orderBy(filteredByStatus, [sortColumn.path], [sortColumn.order]);

    // Finally, apply filtering by selected
    if (selectedOnlyFilter)
      sorted = sorted.filter(
        (adr) =>
          adr.assistantDailyReportId in selectedAdrs &&
          selectedAdrs[adr.assistantDailyReportId]
      );

    return sorted;
  };

  loadPreviewData = (selectedAdr) => {
    const { dispatch } = this.props;
    dispatch(adrActions.fetchPreviewData(selectedAdr.assistantDailyReportId)).then(
      (data) => this.setState({ selectedAdrPreviewData: data })
    );
  };

  handleClick_preview = (selectedAdr) => (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.loadPreviewData(selectedAdr);
    this.setState({ selectedAdr });
  };

  handleClick_tr = (selectedAdr) => {
    const { tab } = this.props;
    actionScripts.FETCH_ADR.run(tab.projectId, selectedAdr.assistantDailyReportId);
    this.loadPreviewData(selectedAdr);
    this.setState({ selectedAdr });
  };

  handleClick_batchOpen = (e) => {
    e.preventDefault();
    const { selectedAdrs } = this.state;
    const { tab } = this.props;
    const selectedAdrIds = Object.entries(selectedAdrs)
      .filter((kvp) => kvp[1])
      .map((kvp) => +kvp[0]);
    selectedAdrIds.forEach((adrId) => actionScripts.FETCH_ADR.run(tab.projectId, adrId));
  };

  handleClick_batchDelete = (e) => {
    e.preventDefault();
    this.toggleAlert_deleteConfirm();
  };

  handleClick_batchPdf = (e) => {
    e.preventDefault();
    const { selectedAdrs } = this.state;
    const { dispatch, tab } = this.props;
    const selectedAdrIds = Object.entries(selectedAdrs)
      .filter((kvp) => kvp[1])
      .map((kvp) => +kvp[0]);
    dispatch(cem4601PdfActions.requestPdfs(selectedAdrIds));
  };

  renderAdrSelect = (adr) => {
    return (
      <div className="custom-control custom-checkbox pl-1">
        <input
          type="checkbox"
          name="adrSelect"
          className="align-middle"
          id={`adrSelect_${adr.assistantDailyReportId}`}
          style={{ width: "1.5rem", height: "1.5rem" }}
          value={this.state.selectedAdrs[adr.assistantDailyReportId] || false}
          checked={this.state.selectedAdrs[adr.assistantDailyReportId] || false}
          onClick={this.handleChange_check(adr.assistantDailyReportId)}
          onTouchEnd={this.handleChange_check(adr.assistantDailyReportId)}
          onChange={this.handleChange_check(adr.assistantDailyReportId)}
        />
      </div>
    );
  };

  renderBatchOptions = () => {
    const { selectedAdrs } = this.state;
    const selectedAdrIds = Object.entries(selectedAdrs)
      .filter((kvp) => kvp[1])
      .map((kvp) => +kvp[0]);
    if (selectedAdrIds.length > 0)
      return (
        <div className="mx-2 align-middle">
          <UncontrolledButtonDropdown className="mr-2" color="secondary">
            <DropdownToggle caret outline>
              Batch Actions{" "}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem id="adrBatchOpen" onClick={this.handleClick_batchOpen}>
                Open (All Selected)
              </DropdownItem>
              <DropdownItem id="adrBatchDelete" onClick={this.handleClick_batchDelete}>
                Delete (All Selected)
              </DropdownItem>
              <DropdownItem id="adrBatchPdf" onClick={this.handleClick_batchPdf}>
                Generate PDFs (All Selected)
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
          {selectedAdrIds.length} Daily Reports selected.
        </div>
      );
  };

  renderPreviewLink = (adr) => {
    return (
      <button
        type="button"
        name={`adrOpenLink_${adr.assistantDailyReportId}`}
        id={`adrOpenLink_${adr.assistantDailyReportId}`}
        className="btn btn-outline-secondary btn-sm px-2 align-middle adrlist-preview-btn"
        onClick={this.handleClick_preview(adr)}
        onTouchEnd={this.handleClick_preview(adr)}
      >
        Info
      </button>
    );
  };

  renderPreview = () => {
    const { selectedAdr, selectedAdrPreviewData } = this.state;
    return (
      <AdrPreview
        adr={selectedAdr}
        previewData={selectedAdrPreviewData}
        renderAdrStatus={this.renderAdrStatus}
      />
    );
  };

  renderAdrStatus = (adr) => {
    let statusClass = "";
    let status = "";
    if (adr.isDraft) {
      status = "Draft";
      statusClass = "dark";
    }
    else if (adr.isSubmitted) {
      status = "Submitted";
      statusClass = "primary";
    }
    else if (adr.isSuperseded) {
      status = "Amended";
      statusClass = "secondary";
    } 
    else if (adr.isApproved) {
      status = "Accepted";
      statusClass = "success";
    }
    else if (adr.isRejected && !adr.isSubmitted) {
      status = "Rejected";
      statusClass = "danger";
    }
    statusClass = "span-bubble p-1 bg-" + statusClass;
    return <span className={statusClass}>{status}</span>;
  };

  renderSnippet = (adr) => {
    const superseded = (
      <span className="text-muted text-small w-100">
        <em>Superseded - see amendment</em>
      </span>
    );
    const amend = (
      <span
        className="badge p-1 mr-1"
        style={{ color: "black", border: "0.05rem solid black" }}
      >
        {`Amendment #${adr.amendmentNo}`}
      </span>
    );
    const att = (
      <span
        className="badge p-1 mr-1"
        style={{ color: "black", border: "0.05rem solid black" }}
      >
        <FontAwesomeIcon icon="paperclip" className="fa-fw" />
      </span>
    );
    const ta = (
      <span
        className="badge p-1 mr-1"
        style={{ color: "black", border: "0.05rem solid black" }}
      >
        TA
      </span>
    );
    return (
      <>
        {adr.isSuperseded && superseded}
        {adr.isAmendment && amend}
        {adr.hasAttachments && att}
        {adr.hasTentativeAgreements && ta}
      </>
    );
  };

  renderPager = () => {
    const { listQuery, pageCount, rowCount, fetching } = this.props;
    if (!listQuery) return null;
    const page = listQuery.page;
    const firstRow = rowCount === 0 ? 0 : (page - 1) * listQuery.pageSize + 1;
    const lastRow = Math.min(page * listQuery.pageSize, rowCount);
    return (
      <div className="d-flex flex-wrap align-items-center justify-content-between py-2">
        <div className="d-flex align-items-center">
          <label htmlFor="adrListPageSize" className="mb-0 mr-2">
            <small>Results per page:</small>
          </label>
          <select
            id="adrListPageSize"
            name="adrListPageSize"
            className="custom-select custom-select-sm w-auto mr-3"
            value={listQuery.pageSize}
            onChange={this.handleChange_pageSize}
            disabled={fetching}
          >
            {adrActions.listPageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
          <small className="text-muted">
            {rowCount === 0
              ? "No Daily Reports found."
              : `Showing ${firstRow}–${lastRow} of ${rowCount.toLocaleString()} Daily Reports`}
          </small>
        </div>
        <PageNav
          currPage={page}
          pageCount={pageCount}
          onPageChange={this.handleChange_page}
          disabled={fetching}
          ariaLabel="Daily Report list pages"
        />
      </div>
    );
  };

  render() {
    const {
      sortColumn,
      reportDateFrom,
      reportDateTo,
      selectedOnlyFilter,
      permissions,
      disableAllSort,
      selectedAdr,
      showAlert_deleteConfirm,
    } = this.state;
    const { tab, user, toggleAdrSearchModal, isSearchResult } = this.props;
    const data = this.getData();
    return (
      <React.Fragment>
        <TitleBar
          titleText={
            isSearchResult ? "Daily Report Search Result" : "List of Daily Reports"
          }
          menu={adrListTitleBarMenu}
          disabledActions={{
            refreshAdrList: isSearchResult,
          }}
          handleTitleBarAction={this.handleTitleBarAction}
        />
        <div className="card mx-2 mt-3">
          <div className="card-body p-2">
            <div className="d-flex flex-row pb-2">
              <div className="form-inline form-row flex-grow-1">
                {!isSearchResult && (
                  <>
                    <label htmlFor="reportDateFrom" className="col-form-label mr-2">
                      <b>Report Date:</b>
                    </label>
                    <div className="mr-1 adrlist-date-filter">
                      <DatePicker
                        customInput={<CustomDatePickerInput />}
                        name="reportDateFrom"
                        id="reportDateFrom"
                        selected={reportDateFrom}
                        onChange={this.handleChange_reportDate("from")}
                        selectsStart
                        startDate={reportDateFrom}
                        endDate={reportDateTo}
                        maxDate={reportDateTo}
                        placeholderText="Begin"
                      />
                    </div>
                    <span className="mr-1">–</span>
                    <div className="mr-2 adrlist-date-filter">
                      <DatePicker
                        customInput={<CustomDatePickerInput />}
                        name="reportDateTo"
                        id="reportDateTo"
                        selected={reportDateTo}
                        onChange={this.handleChange_reportDate("to")}
                        selectsEnd
                        startDate={reportDateFrom}
                        endDate={reportDateTo}
                        minDate={reportDateFrom}
                        placeholderText="End"
                      />
                    </div>
                    <button
                      type="button"
                      name="clearReportDates"
                      id="clearReportDates"
                      className="btn btn-outline-secondary mr-2"
                      onClick={this.handleClick_clearReportDates}
                      disabled={!reportDateFrom && !reportDateTo}
                    >
                      Clear
                    </button>
                  </>
                )}
                <button
                  type="button"
                  name="advSearch"
                  id="advSearch"
                  className="btn btn-info"
                  onClick={toggleAdrSearchModal(
                    tab.projectId,
                    {
                      type: projSelectorConstants.USER_ASSIGNED,
                      lookupId: user.userId,
                    },
                    // Modify Search re-runs into this tab; Adv Search opens a new one.
                    isSearchResult ? tab.tabId : undefined
                  )}
                >
                  {isSearchResult ? "Modify Search..." : "Adv Search..."}
                </button>
                <span className="text-muted mx-1">|</span>
                <button
                  type="button"
                  name="createNewAdr"
                  id="createNewAdr"
                  className="btn btn-secondary"
                  onClick={this.handleClick_createNewAdr}
                  disabled={permissions && !permissions.includes(docPermConstants.CREATE)}
                >
                  <FontAwesomeIcon icon="file" className="fa-fw mr-2" />
                  New...
                </button>
              </div>
            </div>
            <div className="d-flex flex-row flex-wrap pb-2">
              <div className="mr-2">
                <FilterGroup
                  filters={["Draft", "Submitted", "Rejected", "Accepted"]}
                  onChange={this.handleChange_statusFilter}
                />
              </div>
              <div className="mr-2">
                <button
                  type="button"
                  name="filterSelected"
                  id="filterSelected"
                  className={`btn ${
                    selectedOnlyFilter ? "btn-success" : "btn-outline-success"
                  }`}
                  onClick={this.handleClick_selectedOnlyFilter}
                >
                  <FontAwesomeIcon icon="check-square" className="fa-fw" />
                </button>
              </div>
              {this.renderBatchOptions()}
            </div>
            <div className="row m-0">
              <div className="col-lg-8 col-sm-12 pr-1 pl-0">
                <div className="adrlist-table-container border">
                  {/* <BlockUi blocking={fetching}> */}
                  <Table
                    className="table table-hover adrlist-table w-100"
                    data={data}
                    idPropName="assistantDailyReportId"
                    columns={this.columns}
                    sortColumn={sortColumn}
                    onSort={this.handleSort}
                    handleClick_tr={this.handleClick_tr}
                    selectedItemId={selectedAdr && selectedAdr.assistantDailyReportId}
                    disableAllSort={disableAllSort}
                  />
                  {/* </BlockUi> */}
                </div>
                {!isSearchResult && this.renderPager()}
              </div>
              <div className="col-lg-4 px-1 adrlist-preview">{this.renderPreview()}</div>
            </div>
          </div>
        </div>
        {showAlert_deleteConfirm && (
          <AlertModal
            alertTitle="Delete"
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText={
              `Are you sure you wish to delete selected Daily Reports?\n` +
              "(Note: you can only delete your own Daily Reports. Any that is not your own will be skipped over."
            }
            acceptCaption={"Yes"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_deleteConfirm}
            toggleAlertModal={this.toggleAlert_deleteConfirm}
            showAlertModal={showAlert_deleteConfirm}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const openAdrList = state.adr.openAdrLists[ownProps.tab.tabId];
  return {
    adrList: openAdrList ? openAdrList.adrList : [],
    searchParams: openAdrList ? openAdrList.searchParams : null,
    // Project list paging (not set for search results)
    listQuery: openAdrList ? openAdrList.query || null : null,
    pageCount: openAdrList ? openAdrList.pageCount || 0 : 0,
    rowCount: openAdrList ? openAdrList.rowCount || 0 : 0,
    user: state.authentication.user,
    fetching: state.adr.fetching,
  };
};

export default connect(mapStateToProps)(AdrList);
